import _ from "lodash";
import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class EnsenyamentsPreinscripcio {
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/ensenyamentsPreinscripcio/`;
  private ensenyamentsPreinscripcio: any[] = [];

  constructor(
    private NotificationsService: NotificationsService,
    private SharedProperties: SharedProperties,
    private $q: ng.IQService,
    private $http: ng.IHttpService
  ) { }

  init(): ng.IPromise<any[]> {
    return this.$http.get(`${this.apiurl}findAll?`)
      .then((response: any) => {
        this.ensenyamentsPreinscripcio = response.data.subetapas;
        _.remove(this.ensenyamentsPreinscripcio, (item: any) => item.codi === "ART");
        return this.ensenyamentsPreinscripcio;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.$q.reject();
      });
  }
}

angularJsApp.service(AppServicesEnum.ENSENYAMENTS_PREINSCRIPCIO_SERVICE, EnsenyamentsPreinscripcio);